import React from 'react';

import MediaQuery from 'react-responsive';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import routes from 'constants/routes';
import { device } from 'helpers/screenSizes';

export const LoginSignupTabWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 10px;
  height: 97%;
  width: 100%;
  font-size: 14px;
  background: ${props => props.theme.primaryBackground};

  @media ${device.down.lg} {
    font-size: 12.1px;
    padding: 0;
  }

  .centerandfont {
    @media ${device.down.xs} {
      text-align: center;
      a {
        font-size: 10px;
      }
    }
  }
`;

export const LoginSignupTab = props => (
  <LoginSignupTabWrapper>
    <div className="d-flex">
      <div className="col-xxs-24 col-xs-10 centerandfont">
        <Link
          to={{
            pathname: routes.login,
            state: { from: props.location },
          }}
        >
          Sign In
        </Link>
      </div>
      <MediaQuery query={device.up.xs}>
        <div className="col-xs-2 pipeseparator">|</div>
        <div className="col-xxs-24 col-xs-11 centerandfont ps-3">
          <Link
            to={{
              pathname: routes.signup,
              state: { from: props.location },
            }}
          >
            Register
          </Link>
        </div>
      </MediaQuery>
      <MediaQuery query={device.down.xs}>
        <div className="col-xxs-24 col-xs-11 centerandfont">
          <Link
            to={{
              pathname: routes.login,
              state: { from: props.location },
            }}
          >
            Register
          </Link>
        </div>
      </MediaQuery>
    </div>
  </LoginSignupTabWrapper>
);
